// extracted by mini-css-extract-plugin
export default {"pay":"pay_pay__pEerj"};